module.exports = __webpack_public_path__ + "media/images/favicons/android-icon-144x144-a52f6db8cc899763b6323df26a78fab6.png";